import styled from 'styled-components';

// Image grid: always 3 images per row
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

`;

// Individual Image
export const Image = styled.img`
  width: 100%;
  height: 95px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 95px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  &:hover .stack-overlay {
    opacity: 1; /* Make stack visible on hover */
  }
`;

export const StackOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(20, 20, 20, 0.5);
  border-radius: 5px;
  opacity: 0; /* Initially hidden */
  transition: opacity 0.3s ease;
`;

export const StackItem = styled.div`
  padding: 4px;
  background-color: white;
  border-radius: 5px;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 20px;
  }
`;
